export default "/profile/images/Pager.svg?eba6acdd6b5c4e485fcc1ede55a048d3";